export default __webpack_public_path__ + "static/media/investors-page.fad53fc4.png";